export default __webpack_public_path__ + "static/media/industry5.a58fce84.png";